<template>
  <div class="flex flex-col w-full max-w-[552px]">
    <Toast position="top-[48px]"></Toast>

    <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
      Reset Password
    </div>

    <div class="text-[1rem] leading-[1.5rem] text-[#433D31] font-semibold pt-[8px]">
      Please enter your email address, and we'll send you an OTP to reset your password
    </div>

    <div class="pt-[40px]">
      <TextInput
        v-model="email"
        class="w-full"
        label="Email Address"
        labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
        placeholder="Enter Email Address"
        :error="emailError"
      />
    </div>

    <div class="mt-[24px] w-full">
      <BaseButton
        solid-classes="h-[56px] bg-[#42362B] border-0 !rounded-[100px] text-white text-[1rem] leading-[1.5rem] font-bold items-center"
        full-width
        disabled-classes="disabled:bg-[#C3C2C1] disabled:border-[#C3C2C1] disabled:cursor-not-allowed"
        :disabled="!canSave || isLoading"
        @click="submit(email)"
      >
        {{ isLoading ? 'Loading...' : 'Next' }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/design/TextInput.vue';
import BaseButton from '@/components/design/BaseButton.vue';
import Toast from '@/components/common/Toast.vue';
import { mapState } from 'vuex';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  components: {
    TextInput,
    BaseButton,
    Toast,
  },
  data() {
    return {
      email: '',
      emailError: '',
    };
  },
  computed: {
    ...mapState('forgotCredentials', ['isLoading']),
    canSave() {
      return EMAIL_REGEX.test(this.email);
    },
  },
  methods: {
    async submit(value) {
      this.emailError = '';
      if (!this.canSave) {
        this.emailError = 'This is an invalid email. Please re-enter a valid email address. ';
        return;
      }

      if (this.isLoading) {
        return;
      }

      try {
        await this.$store.dispatch('forgotCredentials/sendForgotPasswordOtp', value);
        this.$emit('next');
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
